/**
 * Utility to determine the current environment.
 * 
 * Returns true if the app is running:
 * 1. Locally (localhost)
 * 2. On the development domain (dev.jobharvest.com)
 * 3. In a development build (NODE_ENV === 'development')
 */
export const isDevelopment = () => {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('dev.jobharvest.com') ||
    process.env.NODE_ENV === 'development' ||
    process.env.REACT_APP_ENVIRONMENT === 'dev'
  );
};
